<template>
  <button
    class="ui-button"
    :class="[$attrs.class, $props.class]"
    >
    <slot />
    {{ text }}
    <i v-if="svg" :class="svg" />
    <slot name="after" />
  </button>
</template>

<script setup lang="ts">
defineProps<{
	text?: string
	svg?: string
  class?: string|object|any[]
}>()
</script>
